import { CustomizableColors } from "./CustomizableColors";


export const creceaColors:CustomizableColors = {

    primary:{
        light:"rgba(241,241,240, 1)",
        normal:"rgba(154,153,154, 1)",
        dark:"rgba(74,73,74, 1)"
    },

    secondary:"rgba(247,207,113, 1)",
    
    active: {
        default: { normal: "rgba(74,73,74, 1)", hover: "black" },
        dark: { normal: "rgba(74,73,74, 1)", hover: "black" }
    },

    mainNavigation:{
        background:"rgba(74,73,74, 1)",
        backgroundSelected:"rgba(247,207,113, 1)",
        divider:"rgba(247,207,113, 1)",
        color:"white",
        colorSelected:"white"
    }
}